var map = {
	"./medal_svip1.png": 1089,
	"./medal_svip2.png": 1090,
	"./medal_svip3.png": 1091,
	"./medal_svip4.png": 1092,
	"./medal_svip5.png": 1093,
	"./medal_vip1.png": 1094,
	"./medal_vip2.png": 1095,
	"./medal_vip3.png": 1096,
	"./medal_vip4.png": 1097,
	"./medal_vip5.png": 1098,
	"./medal_vip6.png": 1099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1962;